var React = require('react');

function CloseCircleInverted (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"7.5","cy":"7.5","r":"7.5","fill":"#9DA1AF","key":0}),React.createElement("path",{"stroke":"#fff","strokeWidth":"2","d":"M3.707 3.793L11.485 11.571M3.707 11.571L11.485 3.793","key":1})]);
}

CloseCircleInverted.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = CloseCircleInverted;

CloseCircleInverted.default = CloseCircleInverted;
